import { useOutletContext } from "react-router-dom";

const PayrollMonthFilter = () => {
    const { monthYear, setMonthYear } = useOutletContext();

    return (
        <div className="right d-flex justify-content-end mb-3">
            <div className="d-flex align-items-center">
                <label htmlFor="monthYear" className="me-2 fw-bold">
                    Payroll Month:
                </label>

                <input
                    type="month"
                    id="monthYear"
                    name="monthYear"
                    className="form-control"
                    value={monthYear}
                    onChange={(e) => setMonthYear(e.target.value)}
                />
            </div>
        </div>
    );
};

export default PayrollMonthFilter;
